import { useCallback, useEffect } from "react";

import { PlayerWebRTC } from "@blacknut/playerwebrtc";
import {
  FocusableSection,
  inputUI,
  useForceFocusOnMount,
} from "@blacknut/spatialnav-sdk/dist";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@blacknut/react-sdk/dist";
import styles from "./styles.module.scss";

interface VideoOverlayProps {
  onRequestClose: () => void;
  onExitPressed: () => void;
  player: PlayerWebRTC;
}

const VideoOverlay = ({ onExitPressed, onRequestClose, player }: VideoOverlayProps) => {
  const { t } = useTranslation();
  useForceFocusOnMount("/player/relative");

  useEffect(() => {
    player.unBind(); // mouse & keyboard events
    inputUI.destroyGameGamepad();
    inputUI.setupUIGamepad();
  }, []);
  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<unknown>) => {
      if (e.key === "Escape") {
        onRequestClose();
      }
    },
    [onRequestClose],
  );
  return (
    <div className={styles.container} onKeyPress={onKeyDown as any}>
      <FocusableSection className={styles.content} focusKey="relative">
        <Button className={styles.resume} onClick={onRequestClose}>
          {t("exitGame.buttons.back")}
        </Button>
        <Button className={styles.exit} onClick={onExitPressed} variant="secondary">
          {t("exitGame.buttons.exit")}
        </Button>
      </FocusableSection>
    </div>
  );
};
export default VideoOverlay;
